// Guard against double-execution: theme.liquid hard-loads custom.js with <script defer>,
// and Shopify's native "use_custom_js" setting can load the SAME file again. Without this
// guard, a second load would create duplicate intervals, MutationObservers and a second
// add-to-cart click listener (double add-to-cart). Run the whole file at most once.
(function () {
  if (window.__sbCustomInit) return;
  window.__sbCustomInit = true;

function hexToRgba(hex, alpha) {
  hex = hex.trim().replace('#', '');
  var r = parseInt(hex.slice(0, 2), 16);
  var g = parseInt(hex.slice(2, 4), 16);
  var b = parseInt(hex.slice(4, 6), 16);
  return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
}

var applyingColors = false;

function applyBundleColors() {
  if (applyingColors) return;
  applyingColors = true;
  document.querySelectorAll('.sb-bundle-card').forEach(function(card) {
    var highlight = (card.getAttribute('data-highlight') || '').trim();
    if (highlight) {
      if (card.classList.contains('selected')) {
        card.style.setProperty('border-color', highlight, 'important');
        card.style.setProperty('background-color', hexToRgba(highlight, 0.08), 'important');
      } else {
        card.style.removeProperty('border-color');
        card.style.setProperty('background-color', '#FFF8EE', 'important');
      }
    }
  });
  applyingColors = false;
}

function styleGiftRows() {
  document.querySelectorAll('.sb-gift-row').forEach(function(row) {
    if (row.getAttribute('data-gift-styled')) return;
    row.setAttribute('data-gift-styled', '1');
    row.style.setProperty('background-color', '#FC8E01', 'important');
   row.style.setProperty('border-radius', '0 0 12px 12px', 'important');
    row.style.setProperty('padding', '8px 16px', 'important');
    row.style.setProperty('margin-top', '8px', 'important');
    row.style.setProperty('margin-left', '-16px', 'important');
    row.style.setProperty('margin-right', '-16px', 'important');
    row.style.setProperty('margin-bottom', '0px', 'important');
    var label = row.querySelector('.sb-gift-label');
    var value = row.querySelector('.sb-gift-value');
    if (label && label.textContent.includes(' + ')) {
      var parts = label.textContent.split(' + ');
      var valueText = value ? value.textContent.trim() : '';
      var valueParts = valueText.split(' + ');
      var value1 = valueParts[0] ? valueParts[0].trim() : '';
      var value2 = valueParts[1] ? valueParts[1].trim() : valueText;
      row.style.setProperty('flex-direction', 'column', 'important');
      row.style.setProperty('align-items', 'stretch', 'important');
      label.textContent = parts[0].trim();
      label.style.setProperty('color', '#103d85', 'important');
      if (value) {
        value.textContent = value1;
        value.style.setProperty('color', '#103d85', 'important');
        value.style.setProperty('text-decoration', 'line-through', 'important');
      }
      var firstLine = document.createElement('div');
      firstLine.style.cssText = 'display:flex; justify-content:space-between; align-items:center;';
      firstLine.appendChild(label);
      if (value) firstLine.appendChild(value);
      row.insertBefore(firstLine, row.firstChild);
      var secondLine = document.createElement('div');
      secondLine.style.cssText = 'display:flex; justify-content:space-between; margin-top:3px;';
      secondLine.style.setProperty('border-top', '1px solid rgba(255,255,255,0.5)', 'important');
      secondLine.style.setProperty('padding-top', '4px', 'important');
      secondLine.innerHTML =
        '<span style="color:#103d85!important;">' + parts[1].trim() + '</span>' +
        '<span style="color:#103d85!important;text-decoration:line-through;">' + value2 + '</span>';
      row.appendChild(secondLine);
    } else {
      row.querySelectorAll('span').forEach(function(span) {
        span.style.setProperty('color', '#103d85', 'important');
      });
    }
  });
}

function watchBundleCards() {
  var cards = document.querySelectorAll('.sb-bundle-card');
  if (!cards.length) return;
  var observer = new MutationObserver(function(mutations) {
    if (applyingColors) return;
    mutations.forEach(function(m) {
      if (m.attributeName === 'style' || m.attributeName === 'class') {
        setTimeout(applyBundleColors, 10);
      }
    });
  });
  cards.forEach(function(card) {
    observer.observe(card, { attributes: true, attributeFilter: ['style', 'class'] });
  });
}

function initCartButton() {
  var btn = document.querySelector('#sb-atc-btn, button[name="add"]');
  if (!btn) return;
  btn.classList.add('atc-glow');
  setInterval(function() {
    btn.classList.remove('atc-shake');
    void btn.offsetWidth;
    btn.classList.add('atc-shake');
    setTimeout(function() { btn.classList.remove('atc-shake'); }, 600);
  }, 3500);
}

setTimeout(styleGiftRows, 1000);

function interceptSelleasyAddToCart() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('#sb-atc-btn');
    if (!btn) return;

    var form = btn.closest('form') || document.getElementById('sb-checkout-form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    btn.classList.add('is-loading');

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        if (item.status) {
          // Shopify returned an error (e.g. sold out) instead of a line item
          console.error('Add to cart error:', item.description || item.message);
          btn.classList.remove('is-loading');
          return;
        }
        if (window.Shopify && Shopify.getCart) {
          Shopify.getCart(function(cart) {
            document.body.classList.add('cart-sidebar-show');
            if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
              window.sharedFunctions.updateSidebarCart(cart);
            }
            btn.classList.remove('is-loading');
          });
        }
      })
      .catch(function(err) {
        console.error('Add to cart failed:', err);
        btn.classList.remove('is-loading');
      });
  }, true); // capture phase + stopImmediatePropagation = we fully own this click before Selleasy's own handler runs
}

function relocateScrollingBar() {
  var bar = document.querySelector('.scrolling-bar');
  var descSection = document.querySelector('product-tab.productView-tab, .productView-tab, .halo-product-tab');
  if (bar && descSection) {
    descSection.parentNode.insertBefore(bar, descSection);
    bar.style.setProperty('margin', '0 0 16px 0', 'important');
    bar.style.setProperty('border-radius', '0', 'important');
  }
  if (bar) bar.classList.add('ready');
}

function deduplicateTabs() {
  var tabs = document.querySelectorAll('.pib-section');
  if (tabs.length > 1) tabs[0].parentNode.removeChild(tabs[0]);
}

function syncVariantImage() {
  if (window._sbWrapped) return;
  window._sbWrapped = true;
  var pageLoadTime = Date.now();
  var original = window.sbSelectBundle;

  window.sbSelectBundle = function(element) {
    if (window._autoplayTriggered) return;
    if (original) original(element);
    if (Date.now() - pageLoadTime < 4000) return;
    window._autoplayStopped = true;
    if (window._autoplayInterval) {
      clearInterval(window._autoplayInterval);
      window._autoplayInterval = null;
    }
    var variantId = element.getAttribute('data-variant');
    if (!variantId) return;
    fetch('/variants/' + variantId + '.js')
      .then(function(r) { return r.json(); })
      .then(function(v) {
        if (!v.featured_image) return;
        var rawFile = v.featured_image.src.split('/').pop().split('?')[0];
        var baseName = rawFile.replace(/\.[^.]+$/, '');
        baseName = baseName.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)$/, '');
        var slides = document.querySelectorAll('.productView-for .slick-slide:not(.slick-cloned)');
        var targetIndex = -1;
        slides.forEach(function(slide, i) {
          if (targetIndex >= 0) return;
          var img = slide.querySelector('img');
          if (!img) return;
          var src = img.getAttribute('data-src') || img.getAttribute('src') || '';
          var srcset = img.getAttribute('data-srcset') || img.getAttribute('srcset') || '';
          var combined = src + ' ' + srcset;
          if (combined.includes('/' + baseName + '.') || combined.includes('/' + baseName + '_')) targetIndex = i;
        });
        if (targetIndex >= 0 && window.jQuery) {
          setTimeout(function() {
            jQuery('.productView-for').slick('slickGoTo', targetIndex);
            jQuery('.productView-nav').slick('slickGoTo', targetIndex);
          }, 400);
        }
      });
  };
}

function attachToCard(card) {
  if (card._sbImgListened) return;
  card._sbImgListened = true;
  // NOTE: previously called an undefined switchImageForCard(card) here, which threw a
  // ReferenceError on every bundle-card click. Image switching is already handled by
  // the sbSelectBundle wrapper in syncVariantImage(), so this listener is now a no-op
  // placeholder. Safe to delete attachToCard entirely (and the two calls below) if you
  // don't need a hook here for anything else.
  card.addEventListener('click', function(e) {
    if (!e.isTrusted) return;
  });
}

// Attach to cards already in DOM
document.querySelectorAll('.sb-bundle-card').forEach(attachToCard);

// Watch for cards added later
new MutationObserver(function(mutations) {
  mutations.forEach(function(m) {
    m.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      if (node.classList && node.classList.contains('sb-bundle-card')) attachToCard(node);
      node.querySelectorAll('.sb-bundle-card').forEach(attachToCard);
    });
  });
}).observe(document.body, { childList: true, subtree: true });

function startSliderAutoplay() {
  if (!window.jQuery) return;
  var idx = 0;

  function advance() {
    var $slider = jQuery('.productView-for');
    if (!$slider.length || !$slider.hasClass('slick-initialized')) return;
    var total = $slider.slick('getSlick').slideCount;
    idx = (idx + 1) % total;
    window._autoplayTriggered = true;
    $slider.slick('slickGoTo', idx);
    jQuery('.productView-nav').slick('slickGoTo', idx);
    setTimeout(function() { window._autoplayTriggered = false; }, 1500);
  }

  function startInterval() {
    // Don't run while hovered, or after the shopper picked a variant (which stops autoplay for good)
    if (window._autoplayInterval || window._autoplayPaused || window._autoplayStopped) return;
    window._autoplayInterval = setInterval(advance, 2000);
  }

  function stopInterval() {
    if (window._autoplayInterval) {
      clearInterval(window._autoplayInterval);
      window._autoplayInterval = null;
    }
  }

  // Pause the auto-scroll whenever the shopper hovers over the product images, resume on leave
  var gallery = document.querySelector('.halo-productView-left, .productView-images');
  if (gallery) {
    gallery.addEventListener('mouseenter', function() {
      window._autoplayPaused = true;
      stopInterval();
    });
    gallery.addEventListener('mouseleave', function() {
      window._autoplayPaused = false;
      startInterval();
    });
    // Touch devices have no hover: the moment the shopper touches/swipes the
    // images, stop the auto-scroll for good so it doesn't fight their swipe.
    gallery.addEventListener('touchstart', function() {
      window._autoplayStopped = true;
      stopInterval();
    }, { passive: true });
  }

  // Wait 4s for Selleasy to fully init before starting autoplay
  setTimeout(function() {
    if (window._autoplayPaused || window._autoplayStopped) return;
    // Continue from whatever image is actually showing so we always advance in
    // order (image 1 -> 2 -> 3 ...) instead of jumping out of sequence.
    var $slider = jQuery('.productView-for');
    if ($slider.length && $slider.hasClass('slick-initialized')) {
      idx = $slider.slick('slickCurrentSlide') || 0;
    }
    advance();
    startInterval();
  }, 3000);
}

setTimeout(function() {
  applyBundleColors();
  watchBundleCards();
  styleGiftRows();
  relocateScrollingBar();
  deduplicateTabs();
  initCartButton();
  syncVariantImage();
  startSliderAutoplay();
  interceptSelleasyAddToCart();
}, 300);

})();